import api from './clients';
import { Supplier, CreateSupplierDto, UpdateSupplierDto } from '../types/supplier';
import { buildQueryString } from '../lib/pagination';

interface GetSuppliersParams {
  search?: string;
  page?: number;
  limit?: number;
}

export const suppliersApi = {
  getAll: async (params?: GetSuppliersParams) => {
    const query = buildQueryString({
      search: params?.search,
      page: params?.page,
      limit: params?.limit,
    });

    const response = await api.get(`/proveedores${query}`);
    return response.data;
  },
  getById: async (id: number): Promise<Supplier> => {
    const response = await api.get(`/proveedores/${id}`);
    return response.data?.data || response.data;
  },
  create: async (data: CreateSupplierDto): Promise<Supplier> => {
    const response = await api.post('/proveedores', data);
    return response.data?.data || response.data;
  },
  update: async (id: number, data: UpdateSupplierDto): Promise<Supplier> => {
    const response = await api.put(`/proveedores/${id}`, data);
    return response.data?.data || response.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/proveedores/${id}`);
  },
};

export const exportarProveedoresPDF = async (search?: string): Promise<string> => {
  try {
    const params = search && search.trim() ? { search: search.trim() } : {};
    const response = await api.get('/proveedores/exportar-pdf', { params });

    if (response.data.success && response.data.data?.url) {
      let url = response.data.data.url;

      if (url.startsWith('/') || url.startsWith('./')) {
        const baseApiUrl = import.meta.env.VITE_API_URL || '';
        const backendDomain = baseApiUrl.replace(/\/api$/, '') || window.location.origin;

        if (url.startsWith('./')) {
          url = url.substring(1);
        }

        const cleanUrl = url.startsWith('/') ? url : `/${url}`;
        url = `${backendDomain}${cleanUrl}`;
      }

      return url;
    }

    throw new Error('La respuesta no contiene una URL válida');
  } catch (error) {
    console.error('Error exportando PDF de proveedores:', error);
    throw error;
  }
};

export default api;